const IconRightCaret = () => {
  return (
    <path
      d="M10.25 8.5C13.05 11.3 13.75 12 13.75 12L10.25 15.5"
      stroke="currentColor"
      strokeWidth="1.4"
      strokeLinecap="square"
      data-testid="icon-right-caret"
      fill="none"
    />
  );
};

export default IconRightCaret;
